// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-form-dialog[data-v-305b4922] .el-dialog {\n  margin-top: 5vh !important;\n  top: 0 !important;\n}\n.custom-form-dialog[data-v-305b4922] .el-dialog .el-dialog__body {\n    padding: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
